import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/submitted-review.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-16edff20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 verify-container d-flex justify-center" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Account Successfully Created"),
    /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, " Please verify your account via email. Kindly check your inbox for the vertification process. ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
        class: "btn btn-new-design-secondary w-180-px"
      }, " Back to Home ")
    ])
  ]))
}